import SharedDateInput from '../shared/DateInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/commercialFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface CommercialDateInputProps {
  label: string;
  date: Date;
  onChange: any;
  section: number;
  required?: boolean;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  subLabel?: string;
  disabled?: boolean;
  isClearable?: boolean;
}

const noop = () => ({ type: 'commercialForm/noop' });

const CommercialDateInput = (props: CommercialDateInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark: noop,
    removeRemark: noop,
    updateRemark: noop,
    addFile: noop,
    removeFile: noop,
  };

  return (
    <SharedDateInput
      {...props}
      formStateKey="commercialForm"
      formActions={formActions}
    />
  );
};

export default CommercialDateInput;
